import LotCard from './lot-card'

export default LotCard
